import React from 'react';
import { Box, Chip } from '@mui/material';

/** 메뉴 라벨 + 선택적 badge 칩 (예: New) */
const MenuTitleWithBadge = ({ title, badge, sx }) => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: 0.75,
      minWidth: 0,
      ...sx,
    }}
  >
    <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
      {title}
    </Box>
    {badge ? (
      <Chip
        label={badge}
        size="small"
        color="primary"
        variant="outlined"
        sx={{
          height: 22,
          flexShrink: 0,
          fontSize: '0.8rem',
          fontWeight: 700,
          letterSpacing: 0.2,
          '& .MuiChip-label': { px: 0.9, py: 0 },
        }}
      />
    ) : null}
  </Box>
);

export default MenuTitleWithBadge;
